<template>
  <router-link
    :to="to"
    class="block bg-white border border-gray-200 rounded-lg transition-colors hover:border-primary"
    :class="compact ? 'px-4 py-3.5' : 'px-5 py-4'"
  >
    <div
      class="flex items-center gap-2 font-bold text-gray-900"
      :class="compact ? 'text-sm' : 'mb-1 text-base'"
    >
      <span class="flex-1">{{ title }}</span>
      <span
        v-if="featured"
        class="inline-flex items-center gap-0.5 flex-shrink-0 px-2 py-0.5 text-xs font-bold text-primary bg-primary-50 rounded-full"
        >★ Featured</span
      >
    </div>
    <div v-if="!compact && excerpt" class="text-sm text-gray-700">
      {{ excerpt }}
    </div>
  </router-link>
</template>

<script>
export default {
  name: "ArticleListItem",
  props: {
    title: {
      type: String,
      required: true
    },
    excerpt: {
      type: String,
      default: ""
    },
    to: {
      type: [String, Object],
      required: true
    },
    compact: {
      type: Boolean,
      default: false
    },
    featured: {
      type: Boolean,
      default: false
    }
  }
};
</script>
